import { render, staticRenderFns } from "./TableRiskAppraisalEp_3x3.vue?vue&type=template&id=0df3e48c&scoped=true"
import script from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp_3x3.vue?vue&type=style&index=0&id=0df3e48c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3e48c",
  null
  
)

export default component.exports